module.exports = __webpack_public_path__ + "static/media/loader.cce4b2cd.gif";